export const MONTH_DAY = /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
const PARIS_MONTH_DAY = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Paris',
    month: '2-digit',
    day: '2-digit',
});
/** `MM-DD` in Paris at `now`. */
export function parisMonthDay(now) {
    const parts = PARIS_MONTH_DAY.formatToParts(new Date(now));
    const month = parts.find((part) => part.type === 'month')?.value ?? '01';
    const day = parts.find((part) => part.type === 'day')?.value ?? '01';
    return `${month}-${day}`;
}
/** Whether `monthDay` falls inside the window; `MM-DD` strings compare in calendar order. */
export function inSaleWindow(window, monthDay) {
    return window.from <= window.until
        ? monthDay >= window.from && monthDay <= window.until
        : monthDay >= window.from || monthDay <= window.until;
}
//# sourceMappingURL=sale-window.js.map